'use client';

import React from 'react';
import { useBloodVision } from '../../BloodVisionContext';
import styles from './CTAButtons.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

export const CTAButtons = () => {
  const { selectedPlan, plans, selectPlanByUser } = useBloodVision();

  const currentPlanIndex = plans.findIndex(
    (plan) => plan.id === selectedPlan?.id,
  );
  const handleScrollToBuy = React.useCallback(
    (index: number) => {
      if (typeof window === 'undefined' || typeof document === 'undefined')
        return;
      const target = document.getElementById('blood-vision-buy-plans');
      if (!target) return;
      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
      if (currentPlanIndex === index) return;
      selectPlanByUser(plans[index]);
    },
    [currentPlanIndex, plans, selectPlanByUser],
  );

  return (
    <div className={styles.buttonsRow}>
      <button
        type="button"
        className={cx(styles.baseButton, styles.secondaryButton)}
        onClick={() => handleScrollToBuy(0)}
      >
        Get the Essential Plan
      </button>
      <button
        type="button"
        className={cx(styles.baseButton, styles.primaryButton)}
        onClick={() => handleScrollToBuy(1)}
      >
        Get the Annual Plan
      </button>
    </div>
  );
};
